export const currencySignMap: Record<string, string> = {
  aud: '$',
  brl: 'R$',
  cad: '$',
  chf: 'CHF',
  dkk: 'kr',
  eur: '€',
  gbp: '£',
  inr: '₹',
  jpy: '¥',
  nok: 'kr',
  nzd: '$',
  pln: 'zł',
  sek: 'kr',
  usd: '$',
};
